module.exports = __webpack_public_path__ + "img/aroma-zone.d86f651.svg";